import { LifeBuoy } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { pylonWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  pylonWeb,
  {
    PylonPage: () => import('./PylonPage'),
    AgentSourcePylonIssueBubble: () => import('./AgentSourcePylonIssueBubble'),
    PylonFlowTriggerSummary: () => import('./PylonFlowTriggerSummary'),
  },
  {
    icons: { LifeBuoy },
  },
);
